export default __webpack_public_path__ + "static/media/expressojk.3bd61401.ico";